export const CLEAR_PRODUCTS_ACTION = 'CLEAR_PRODUCTS'

export type ClearProductsAction = {
  type: typeof CLEAR_PRODUCTS_ACTION
}

export const clearProducts = (): ClearProductsAction => ({
  type: CLEAR_PRODUCTS_ACTION,
})
